if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const control = target?.closest('[data-sb-photo-step]');
        if (!control || !this.classList.contains('sb-photo-mode')) return;
        event.preventDefault();
        this.stepPhoto(Number(control.dataset.sbPhotoStep));
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || !this.classList.contains('sb-photo-mode')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.stepPhoto(event.key === 'ArrowRight' ? 1 : -1);
      });
    }

    hide() {
      super.hide();
      this.classList.remove('sb-photo-mode');
      if (this.photoNav) this.photoNav.hidden = true;
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      const elements = [...this.querySelectorAll('[data-media-id]')];
      const activeMedia = elements.find((element) => element.getAttribute('data-media-id') === mediaId);
      if (!activeMedia) return;
      elements.forEach((element) => element.classList.toggle('active', element === activeMedia));
      const imageMode = activeMedia.tagName === 'IMG';
      this.classList.toggle('sb-photo-mode', imageMode);
      if (imageMode) {
        this.photoImages = [...this.querySelectorAll('.product-media-modal__content > img[data-media-id]')]
          .filter((image) => image === activeMedia || !image.classList.contains('product__media-item--variant'));
        this.photoIndex = this.photoImages.indexOf(activeMedia);
        this.setupPhotoNavigation();
        this.updatePhotoCounter();
        const container = this.querySelector('[role="document"]');
        if (container) { container.scrollLeft = 0; container.scrollTop = 0; }
        return;
      }
      // Preserve Dawn's existing behaviour for videos and 3D models.
      if (this.photoNav) this.photoNav.hidden = true;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent?.querySelector('.js-youtube')) activeMedia.loadContent();
    }

    setupPhotoNavigation() {
      if (this.photoNav) return;
      const dialog = this.querySelector('.product-media-modal__dialog');
      if (!dialog) return;
      const close = dialog.querySelector('.product-media-modal__toggle');
      if (close) close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>';
      const languages = {
        pt: ['Foto anterior', 'Próxima foto'], en: ['Previous photo', 'Next photo'],
        es: ['Foto anterior', 'Siguiente foto'], ru: ['Предыдущее фото', 'Следующее фото']
      };
      const language = (document.documentElement.lang || 'pt').toLowerCase().split('-')[0];
      const labels = languages[language] || languages.pt;
      const navigation = document.createElement('div');
      navigation.className = 'sb-photo-nav';
      const counter = document.createElement('span');
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const buttons = [-1, 1].map((step, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.sbPhotoStep = String(step);
        button.setAttribute('aria-label', labels[index]);
        button.innerHTML = arrow;
        return button;
      });
      navigation.append(buttons[0], counter, buttons[1]);
      dialog.append(navigation);
      this.photoNav = navigation;
      this.photoCounter = counter;
    }

    stepPhoto(step) {
      if (!this.photoImages?.length || !Number.isFinite(step)) return;
      this.photoIndex = (this.photoIndex + step + this.photoImages.length) % this.photoImages.length;
      this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((element) => {
        element.classList.toggle('active', element === this.photoImages[this.photoIndex]);
      });
      this.updatePhotoCounter();
    }

    updatePhotoCounter() {
      if (!this.photoNav || !this.photoCounter) return;
      this.photoNav.hidden = this.photoImages.length < 2;
      this.photoCounter.textContent = `${this.photoIndex + 1} / ${this.photoImages.length}`;
    }
  });
}
